import { useCallback, useEffect, useState } from 'react';

import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { useUserConfig } from '../../../../context/UserConfigContext';
import { useUpdateMyConfig } from '../../../../redux/api/users/usersApi';
import { UserConfigKey } from '../../../../shared/constants';
import { Paths } from '../../../../shared/paths';

export function useNotificationsEditComponent() {
  const { config, options } = useUserConfig();
  const { replace } = useNavigationStack();
  const [updateMyConfig, { isLoading }] = useUpdateMyConfig();
  const [systemPush, setSystemPush] = useState(false);
  const [socialPush, setSocialPush] = useState(false);
  const [marketingPush, setMarketingPush] = useState(false);
  const [remindersPush, setRemindersPush] = useState(false);

  useEffect(() => {
    if (config) {
      setSystemPush(options.notificationsSystemPushEnabled);
      setSocialPush(options.notificationsSocialPushEnabled);
      setMarketingPush(options.notificationsMarketingPushEnabled);
      setRemindersPush(options.notificationsRemindersPushEnabled);
    }
  }, [config, options]);

  const handleSave = useCallback(() => {
    updateMyConfig({
      config: [
        {
          key: UserConfigKey.notificationsSystemPushEnabled,
          value: String(systemPush),
        },
        {
          key: UserConfigKey.notificationsSocialPushEnabled,
          value: String(socialPush),
        },
        {
          key: UserConfigKey.notificationsMarketingPushEnabled,
          value: String(marketingPush),
        },
        {
          key: UserConfigKey.notificationsRemindersPushEnabled,
          value: String(remindersPush),
        },
      ],
    })
      .unwrap()
      .then(() => {
        replace(Paths.settings.toNotificationsView);
      });
  }, [
    systemPush,
    socialPush,
    marketingPush,
    remindersPush,
    updateMyConfig,
    replace,
  ]);

  const isDirty =
    systemPush !== options.notificationsSystemPushEnabled ||
    socialPush !== options.notificationsSocialPushEnabled ||
    marketingPush !== options.notificationsMarketingPushEnabled ||
    remindersPush !== options.notificationsRemindersPushEnabled;

  return {
    systemPush,
    setSystemPush,
    socialPush,
    setSocialPush,
    marketingPush,
    setMarketingPush,
    remindersPush,
    setRemindersPush,
    handleSave,
    isLoading,
    isDirty,
  };
}
